import * as React from "react"
import { useGoToSignInHome } from "src/frontend/components/Public/LogIn/Glow/useGoToSignInHome"
import { useResendMagicLink } from "src/frontend/components/Public/LogIn/Glow/useSendMagicLink"
import { useOnboardingContext } from "src/frontend/components/Public/Onboarding/OnboardingContext"
import { Email, EmailNotification } from "src/frontend/components/Shared/Glow/EmailNotification"

export const MagicLinkExpired: React.FC = () => {
  const {
    state: { emailAddress },
  } = useOnboardingContext()
  const goHome = useGoToSignInHome()
  const { onMagicLinkClick, magicLinkLoading, disabled } = useResendMagicLink()

  return (
    <EmailNotification
      onBack={goHome}
      onClick={onMagicLinkClick}
      disabled={magicLinkLoading || disabled}
      title="Magic Link Expired!"
    >
      It looks like the magic link sent to <Email>{emailAddress}</Email> has expired.
    </EmailNotification>
  )
}
